module.exports = { "default": require("core-js/library/fn/object/freeze"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/motion/js-deps/~/babel-runtime/core-js/object/freeze.js
 ** module id = 76
 ** module chunks = 1
 **/